import { ClienteAnaliseMercadoRAPClienteOptions } from './cliente-analise-mercado-rap-cliente.options';
import { isTipoPessoaCentralCompras } from '../../../pessoa/tipo';
import { isClienteAnaliseMercadoPeriodicidadeAnual, isClienteAnaliseMercadoPeriodicidadeMediaMensal, isClienteAnaliseMercadoPeriodicidadeMensal } from '../../domain/cliente-analise-mercado-periodicidade.enum';

/** Response com os dados de um cliente na consulta da Análise de Mercado RAP */
export class ClienteAnaliseMercadoRAPClienteResponse {
    idCliente: number;
    idPessoa: number;
    tipoPessoa: number;
    private _isCentralCompras: boolean;
    cnpjCpfCliente: string;
    codigoIntegracaoErpCliente: string;
    nomeCliente: string;
    nomeFantasiaCliente: string;
    cadastro: number;
    situacao: number;
    motivoBaixaCliente: string;
    idRepresentante: number;
    codigoIntegracaoErpRepresentante: string;
    nomeRepresentante: string;
    nomeFantasiaRepresentante: string;
    idClienteCentralCompra: number;

    // Lançamento
    idClienteAnaliseMercado: number;
    periodicidade: number;
    private _isPeriodicidadeAnual: boolean;
    private _isPeriodicidadeMediaMensal: boolean;
    private _isPeriodicidadeMensal: boolean;

    // Sell In Cliente (Potencial)
    valorPotencialAnoAnterior1: number;
    valorPotencial: number;

    // Customer Share RAP (Pretendido)
    valorPretendidoAnoAnterior1: number;
    valorPretendido: number;
    customerShareRAP: number;
    indicadorCustomerShareRAP: number;
    idClassificacaoRAP: number;
    nomeClassificacaoRAP: string;

    // Customer Share RAP (Projetado)
    valorProjetadoAnoAnterior1: number;
    valorProjetado: number;
    customerShareRAPProjetado: number;
    indicadorCustomerShareRAPProjetado: number;

    // Customer Share RAR (Realizado)
    valorRealizadoAnoAnterior2: number;
    valorRealizadoAnoAnterior1: number;
    valorRealizado: number;
    customerShareRAR: number;
    indicadorCustomerShareRAR: number;
    valorRealizadoPercPretendido: number;
    valorRealizadoPercProjetado: number;
    idClassificacaoRAR: number;
    nomeClassificacaoRAR: string;

    options: ClienteAnaliseMercadoRAPClienteOptions;

    constructor(props: Partial<ClienteAnaliseMercadoRAPClienteResponse>) {
        Object.assign(this, props);
        this._isCentralCompras = isTipoPessoaCentralCompras(this.tipoPessoa);

        // Períodidicdades
        this._isPeriodicidadeAnual = isClienteAnaliseMercadoPeriodicidadeAnual(props.periodicidade);
        this._isPeriodicidadeMediaMensal = isClienteAnaliseMercadoPeriodicidadeMediaMensal(props.periodicidade);
        this._isPeriodicidadeMensal = isClienteAnaliseMercadoPeriodicidadeMensal(props.periodicidade);
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): ClienteAnaliseMercadoRAPClienteResponse {
        return new ClienteAnaliseMercadoRAPClienteResponse(JSON.parse(json));
    }

    /** Atualiza os dados da Classificação RAP */
    updateClassificacaoRAP(id: number, nome: string) {
        this.idClassificacaoRAP = id;
        this.nomeClassificacaoRAP = nome;
    }

    /** Verifica se é uma Central de Compras */
    get isCentralCompras(): boolean {
        return this._isCentralCompras;
    }

    /** Verifica se a periodicidade do lançamento é anual */
    get isPeriodicidadeAnual(): boolean {
        return this._isPeriodicidadeAnual;
    }

    /** Verifica se a periodicidade do lançamento é média mensal */
    get isPeriodicidadeMediaMensal(): boolean {
        return this._isPeriodicidadeMediaMensal;
    }

    /** Verifica se a periodicidade do lançamento é mensal */
    get isPeriodicidadeMensal(): boolean {
        return this._isPeriodicidadeMensal;
    }

    /** Se pode editar o lançamento */
    get canEditLancamento(): boolean {
        // Quando for a periodicidade anual ou ainda não possuir o lançamento criado
        return this.isPeriodicidadeAnual || !this.idClienteAnaliseMercado;
    }
}
